import {Component, ViewChild} from '@angular/core';
import {ClienteService} from "../../../services/cliente.service";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import {ListaPessoa} from "../../../models/lista-pessoa";
import {ItemPessoa} from "../../../models/item-pessoa";
import {NovoClienteComponent} from "../novo-cliente/novo-cliente.component";

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild('novoComp') novoClienteComponente: NovoClienteComponent;
  loading = true;
  listaClientes = new ListaPessoa();
  habilitarNovo = false;
  habilitarDetalhes = false;
  clienteIdSelecionado = 0;

  termoBusca = '';
  filtro = false;
  paginaAtual = 1;

  constructor(private clienteService: ClienteService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.buscarListaClientes();
  }

  public abrirModalNovo(){
    this.habilitarNovo = true;
  }

  public fecharModalNovo(){
    this.habilitarNovo = false;
  }

  public abrirModalDetalhes(id: number){
    this.clienteIdSelecionado = id;
    this.habilitarDetalhes = true;
  }

  public fecharModalDetalhes(){
    this.habilitarDetalhes = false;
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  limparFiltro(){
    this.termoBusca = '';
    this.filtro = false;
  }

  buscarLista(){
    if(this.termoBusca.length > 0){
      this.filtro = true;
    }
    else{
      this.filtro = false;
    }
  }

  get listaFiltrada() {
    if (!this.listaClientes || !this.listaClientes.itens) {
      return [];
    }
    if (this.filtro) {
      return this.listaClientes.itens.filter(item => {
        return Object.keys(item).some(key => (item as any)[key]?.toString().toLowerCase().includes(this.termoBusca.toLowerCase()));
      });
    }
    return this.listaClientes.itens;
  }

  buscarListaClientes(){
    this.loading = true;
    this.listaClientes = new ListaPessoa();
    this.clienteService.selecionarLista().subscribe(response => {
      if(response.sucesso){
        this.listaClientes = response.dados;
        this.loading = false;
      }
    }, error =>{
      if(error.status === 404){
        this.toastr.warning("Lista de clientes vazia");
      }
      else{
        this.toastr.error("Erro ao buscar a listagem - HTTP " + error.status );
      }
      this.loading = false;
    });
  }
}
